import { SecurityType } from '../../../graphql';

export type GetInstrumentNameArgs = {
  issuerName: string | null;
  securityTypeDisplayName: string | null;
  stockSymbol: string | null;
  isDepositaryReceipt: boolean;
};

export function getInstrumentName({
  issuerName,
  securityTypeDisplayName,
  stockSymbol,
  isDepositaryReceipt,
}: GetInstrumentNameArgs) {
  const nameParts = [issuerName, securityTypeDisplayName, stockSymbol].filter(Boolean);
  const name = nameParts.join(' - ') || '-';

  return isDepositaryReceipt ? `Depositary Receipt: ${name}` : name;
}

export type GetAllocationUnitBasedOnSecurityTypeArgs = {
  securityType: SecurityType | null;
  prefix?: string;
};

export function getAllocationUnitBasedOnSecurityType({
  securityType,
  prefix = '# of',
}: GetAllocationUnitBasedOnSecurityTypeArgs) {
  const unit = securityType === SecurityType.ConvertibleBond ? 'Bonds' : 'Shares';

  return `${prefix} ${unit}`.trim();
}
